interface CycleStageCardProps {
  description: string;
  height: number;
  tag: string;
  title: string;
  variant: "pre-release" | "launch" | "post-release";
}

const CycleStageCard: React.FC<CycleStageCardProps> = ({
  description,
  height,
  tag,
  title,
  variant,
}) => {
  return (
    <article
      className={`cycle-stage-card cycle-stage-card--${variant}`}
      style={{ minHeight: `${height}px` }}
    >
      <span className="cycle-stage-card__tag body-small">{tag}</span>
      <h2 className="cycle-stage-card__title heading-h5">{title}</h2>
      <p className="cycle-stage-card__description body-regular">{description}</p>
    </article>
  );
};

export default CycleStageCard;
